import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    fuels: {
        objectId: null,
        fiscalYearOverridesActive: false,
        fiscalYearOverridesDate: null,
        defaultFiscalYearDate: new Date(Date.UTC(new Date().getUTCFullYear(), 9, 15)).toISOString()
    },
    postFire: {
        objectId: null,
        fiscalYearOverridesActive: false,
        fiscalYearOverridesDate: null,
        defaultFiscalYearDate: new Date(Date.UTC(new Date().getUTCFullYear(), 9, 15)).toISOString()
    }

}

export const globalOverridesSlice = createSlice(
    {
        name: 'globalOverride',
        initialState,
        reducers: {
            setObjectId: (state, action) => {
                const {module, objectId} = action.payload;
                if (state[module]) {
                    state[module].objectId = objectId;
                }
            },
            setFiscalYearOverridesActive: (state, action) => {
                const { module, isActive } = action.payload;
                if (state[module]) {
                    state[module].fiscalYearOverridesActive = isActive;
                }
            },
            setFiscalYearOverridesDate: (state, action) => {
                const { module, date } = action.payload;
                if (state[module]) {
                    state[module].fiscalYearOverridesDate = date;
                }
            },
            setDefaultFiscalYearDate: (state, action) => {
                const { module, date } = action.payload;
                if (state[module]) {
                    state[module].defaultFiscalYearDate = date;
                }
            }
        }
    }
);

export const {setFiscalYearOverridesActive, setFiscalYearOverridesDate, setObjectId} = globalOverridesSlice.actions;
export default globalOverridesSlice.reducer;